export enum FeeTypes {
  None = 0,

  AgentBookingFee = 1,
  OnlineBookingFee = 2,
  ProcessingFee = 3,
  GuestFee = 4,
  PartnerAgentFee = 5,
  PartnerOnlineFee = 6,

  AgentFeeOverride = 101,
  ProcessingPointsFeeOverride = 103,
  PartnerAgentFeeOverride = 105
}

export enum FeeOverrideType {
  None = FeeTypes.None,
  AgentFeeOverride = FeeTypes.AgentFeeOverride,
  ProcessingPointsFeeOverride = FeeTypes.ProcessingPointsFeeOverride,
  PartnerAgentFeeOverride = FeeTypes.PartnerAgentFeeOverride
}

export const OVERRIDE_OFFSET = 100;
